var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 12.3301V3.83008C1.5 3.55394 1.72386 3.33008 2 3.33008H14C14.2761 3.33008 14.5 3.55394 14.5 3.83008V12.3301C14.5 12.3301 14.5 12.7443 14.2071 13.0372C14.2071 13.0372 13.9142 13.3301 13.5 13.3301H2.5C2.5 13.3301 2.08579 13.3301 1.79289 13.0372C1.79289 13.0372 1.5 12.7443 1.5 12.3301ZM2.5 12.3301H13.5V4.33008H2.5V12.3301Z",
    fill: "#5932EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.33786 3.4615C2.24565 3.37697 2.1251 3.33008 2 3.33008C1.99276 3.33008 1.98552 3.33024 1.97828 3.33055C1.8458 3.33631 1.72103 3.39446 1.63142 3.49222C1.54689 3.58443 1.5 3.70498 1.5 3.83008C1.5 3.83732 1.50016 3.84456 1.50047 3.8518C1.50623 3.98428 1.56438 4.10905 1.66214 4.19866L7.66214 9.69866C7.8533 9.87389 8.1467 9.87389 8.33786 9.69866L14.3375 4.19896C14.4408 4.10426 14.5 3.97023 14.5 3.83008L14.5 3.82592C14.499 3.70226 14.4521 3.58337 14.3686 3.49222C14.279 3.39446 14.1542 3.33631 14.0217 3.33055C14.0145 3.33024 14.0072 3.33008 14 3.33008L13.9977 3.33008C13.8734 3.33066 13.7538 3.37751 13.6621 3.4615L8 8.65179L2.33786 3.4615Z",
    fill: "#5932EA"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.7447b81a7eaa6fb950a905a491babb63.svg";
export { ForwardRef as ReactComponent };